import EmployeeComponent from 'components/Settings/Approval/Employee';
import PermissionGuard from 'components/Global/PermissionGuard';
import './index.scss';

export const Employee = () => {
	return (
		<PermissionGuard isAdmin={true}>
			<div className="time-logs-container">
				<EmployeeComponent />
			</div>
		</PermissionGuard>
	);
};
